import { createRef } from "react";
import SettingsPage from "../pages/SettingsPage";

// feature routes
export const routes = [
  {
    path: "/settings",
    element: <SettingsPage />,
    handle: {
      name: "Settings",
      nodeRef: createRef(),
    },
  },
];
